import React from "react";
import styled from "styled-components";
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, TextField } from "@material-ui/core";
import { RawLinkButton } from "../LinkButton";

const WarningMessage = styled.div`
  font-weight: bold;
  color: red;
`;

export interface IConfirmationTextDialogProps {
  isOpen: boolean;
  title: string;
  confirmationText: string;
  contentTexts: string[];
  buttonText: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmationTextDialog = (props: IConfirmationTextDialogProps) => {
  const { isOpen, title, confirmationText, contentTexts, buttonText, onConfirm, onCancel } = props;

  const [confirmText, setConfirmText] = React.useState<string>("");

  const [confirmTextError, setConfirmTextError] = React.useState<boolean>(false);

  const onTryConfirm = () => {
    if (confirmText === confirmationText) {
      onConfirm();
    } else {
      setConfirmTextError(true);
    }
  };

  return (
    <Dialog open={isOpen} onClose={onCancel} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <WarningMessage>Are you sure you want to do this?</WarningMessage>
        </DialogContentText>
        {contentTexts.map((text, index) => (
          <DialogContentText key={index}>{text}</DialogContentText>
        ))}
        {confirmTextError && (
          <DialogContentText>
            <WarningMessage>The confirmation text did not match {confirmationText}</WarningMessage>
          </DialogContentText>
        )}
        <TextField
          autoFocus
          margin="dense"
          id="confirmText"
          label="Text is case sensitive"
          type="text"
          fullWidth
          onChange={e => {
            setConfirmTextError(false);
            setConfirmText(e.target.value);
          }}
        />
      </DialogContent>
      <DialogActions>
        <RawLinkButton onClick={onTryConfirm}>{buttonText}</RawLinkButton>
        <RawLinkButton onClick={onCancel}>Cancel</RawLinkButton>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationTextDialog;
